import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { DatePipe , registerLocaleData} from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NZ_I18N , en_US } from 'ng-zorro-antd/i18n';

import en from '@angular/common/locales/en';
import { NzFormModule } from 'ng-zorro-antd/form';
import { ReactiveFormsModule } from '@angular/forms';
import { NzMessageModule } from 'ng-zorro-antd/message';
import { HeadersInterceptor } from 'src/app/shared/interceptor/headers.interceptor';
import {  HTTP_INTERCEPTORS } from '@angular/common/http';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { BookingComponent } from './pages/common/customer/booking/booking.component';
import { Step1Component } from './pages/common/customer/steps/step1/step1.component';
import { Step2Component } from './pages/common/customer/steps/step2/step2.component';
import { Step3Component } from './pages/common/customer/steps/step3/step3.component';
import { Step4Component } from './pages/common/customer/steps/step4/step4.component';
import { Step5Component } from './pages/common/customer/steps/step5/step5.component';
import { BookingManagementComponent } from './pages/components/booking-management/booking-management.component';
import { LanguageIntercepter } from './shared/interceptor/language.interceptor';
import { DashboardComponent } from "./pages/components/dashboard/DashboardComponent";
import { WorkingDaysTimeComponent } from './pages/components/working-days-time/working-days-time.component';


import { SuccessPaymentComponent } from './pages/common/success-payment/success-payment.component';
import { LoginComponent } from './pages/common/auth/login/login.component';
import { RegisterComponent } from './pages/common/auth/register/register.component';

import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { PagesCoreComponent } from './pages/pages-core/pages-core.component';
 import { NzInputModule } from 'ng-zorro-antd/input';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
// import { NzListModule } from 'ng-zorro-antd/list';
import { NzButtonModule } from 'ng-zorro-antd/button';
// import { NzStepsModule } from 'ng-zorro-antd/steps';
// import { NzEmptyModule } from 'ng-zorro-antd/empty';

// import { NzGridModule } from 'ng-zorro-antd/grid';
// import { NzCardModule } from 'ng-zorro-antd/card';
// import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzModalModule } from 'ng-zorro-antd/modal';
// import { NzAvatarModule } from 'ng-zorro-antd/avatar';
// import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzBadgeModule } from 'ng-zorro-antd/badge';

// import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzSelectModule } from 'ng-zorro-antd/select';
// import { NzInputNumberModule } from 'ng-zorro-antd/input-number';

import { NzRadioModule } from 'ng-zorro-antd/radio';
// import { NzRateModule } from 'ng-zorro-antd/rate';
// import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
// import { NzUploadModule } from 'ng-zorro-antd/upload';

// import { NzCascaderModule } from 'ng-zorro-antd/cascader';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
// import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzCommentModule } from 'ng-zorro-antd/comment';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';

// import ResizeObserver from 'resize-observer-polyfill';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';


// import { NzAffixModule } from 'ng-zorro-antd/affix';
// import { NzAlertModule } from 'ng-zorro-antd/alert';
// import { NzAnchorModule } from 'ng-zorro-antd/anchor';
// import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
// import { NzBackTopModule } from 'ng-zorro-antd/back-top';
// import { NzCalendarModule } from 'ng-zorro-antd/calendar';
// import { NzCarouselModule } from 'ng-zorro-antd/carousel';
// import { NzNoAnimationModule } from 'ng-zorro-antd/core/no-animation';
// import { NzTransButtonModule } from 'ng-zorro-antd/core/trans-button';
// import { NzWaveModule } from 'ng-zorro-antd/core/wave';
// import { NzDividerModule } from 'ng-zorro-antd/divider';
// import { NzDrawerModule } from 'ng-zorro-antd/drawer';
 import { NzLayoutModule } from 'ng-zorro-antd/layout';
// import { NzMentionModule } from 'ng-zorro-antd/mention';
// import { NzMenuModule } from 'ng-zorro-antd/menu';
// import { NzNotificationModule } from 'ng-zorro-antd/notification';
// import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
// import { NzPopoverModule } from 'ng-zorro-antd/popover';
// import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzResultModule } from 'ng-zorro-antd/result';
// import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';
// import { NzSliderModule } from 'ng-zorro-antd/slider';
import { NzSpinModule } from 'ng-zorro-antd/spin';
// import { NzStatisticModule } from 'ng-zorro-antd/statistic';
// import { NzTimelineModule } from 'ng-zorro-antd/timeline';
// import { NzTransferModule } from 'ng-zorro-antd/transfer';
// import { NzTreeModule } from 'ng-zorro-antd/tree';
// import { NzTreeSelectModule } from 'ng-zorro-antd/tree-select';
// import { NzTypographyModule } from 'ng-zorro-antd/typography';
// import { NzResizableModule } from 'ng-zorro-antd/resizable';

import { NzTableModule } from 'ng-zorro-antd/table';

 import { NzIconModule } from 'ng-zorro-antd/icon';


import { LeftPanelComponent } from '../app/pages/common/left-panel/left-panel.component';
import { RightPanelComponent } from '../app/pages/common/right-panel/right-panel.component';
import { HeaderComponent } from '../app/pages/common/header/header.component';
import { ContentSectionComponent } from '../app/pages/content-section/content-section.component';

import * as echarts from 'echarts';
import { NgxEchartsModule } from 'ngx-echarts';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, '/assets/i18n', '.json');
}

registerLocaleData(en);


export function rootLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    LeftPanelComponent,
    RightPanelComponent,
    HeaderComponent,
    BookingComponent,
    ContentSectionComponent,
    Step1Component,
    Step2Component,
    PagesCoreComponent,
    Step3Component,
    Step4Component,
    Step5Component,
    BookingManagementComponent,
    DashboardComponent,
    WorkingDaysTimeComponent,
    SuccessPaymentComponent,
    LoginComponent,
    RegisterComponent,
  ],
  imports: [
    NzTableModule,
    // NzAlertModule,
    // NzAnchorModule,
    // NzAutocompleteModule,
    // NzAvatarModule,
    // NzBackTopModule,
    NzBadgeModule,
    NzButtonModule,
    // NzBreadCrumbModule,
    // NzCalendarModule,
    // NzCardModule,
    // NzCarouselModule,
    // NzCascaderModule,
    // NzCheckboxModule,
    // NzCollapseModule,
    NzCommentModule,
    NzDatePickerModule,
    NzDescriptionsModule,
    // NzDividerModule,
    // NzDrawerModule,
    NzDropDownModule,
    // NzEmptyModule,
    NzFormModule,
    // NzGridModule,
    NzInputModule,
    // NzInputNumberModule,
     NzLayoutModule,
    // NzListModule,
    // NzMentionModule,
    // NzMenuModule,
    NzMessageModule,
    NzModalModule,
    // NzNoAnimationModule,
    // NzNotificationModule,
    // NzPageHeaderModule,
    NzPaginationModule,
    NzPopconfirmModule,
    // NzPopoverModule,
    // NzProgressModule,
     NzIconModule,
    NzRadioModule,
    // NzRateModule,
    NzResultModule,
    NzSelectModule,
    // NzSkeletonModule,
    // NzSliderModule,
    NzSpinModule,
    // NzStatisticModule,
    // NzStepsModule,
    // NzSwitchModule,
    // NzTabsModule,
    // NzTagModule,
    NzTimePickerModule,
    // NzTimelineModule,
    NzToolTipModule,
    // NzTransButtonModule,
    // NzTransferModule,
    // NzTreeModule,
    // NzTreeSelectModule,
    // NzTypographyModule,
    // NzUploadModule,
    // NzWaveModule,
    // NzResizableModule,
    NzMessageModule,
    // NzLayoutModule,
    // NzMenuModule,
    // NzStepsModule,
    // NzFormModule,
    BrowserModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: rootLoaderFactory,
        deps: [HttpClient],
      },
    }),
    NzMessageModule,
    NzDatePickerModule,
    NzCheckboxModule,
    AppRoutingModule,
    SharedModule.forRoot(),
    NgxEchartsModule.forRoot({
      echarts
    }),
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    // NzFormModule,
    ReactiveFormsModule,

 
  ],

  providers: [  DatePipe, {provide: HTTP_INTERCEPTORS, useClass:HeadersInterceptor, multi: true},  {
    provide: HTTP_INTERCEPTORS,
    useClass: LanguageIntercepter,
    multi: true,
  },    { provide: NZ_I18N, useValue: en_US }
  
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
